import {Virtuoso} from 'react-virtuoso'
import styled, {css} from 'styled-components'

export const StyledVirtualList: typeof Virtuoso = styled(Virtuoso)(
    () => css`
        height: 100%;
        width: 100%;
    `
)

export const StyledAccessesValidatorsList = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 2}px;
    `
)
